// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"CCPA--contentContainer","mainText":"CCPA--mainText","ctaContainer":"CCPA--ctaContainer","formLevelError":"CCPA--formLevelError"};